import { IActivityEntity } from 'src/app/shared-layout/Components/activity/activity.interface';
import { UPDATE_USER_ACTIVITIES, PREPEND_USER_ACTIVITIES, CLEAR_USER_ACTIVITIES } from './actionTypes';

const initialState = {
    id: '',
    events: [],
    totalRecords: 0,
  } as IActivityEntity;

export const userActivitiesReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case UPDATE_USER_ACTIVITIES:
    return {
      ...state,
      events: action.userActivities?.events || [],
      totalRecords: action.userActivities?.totalRecords || state.totalRecords,
      cursor: action.userActivities?.cursor || state.cursor,
      id: action.userActivities?.id || state.id,
    };
    case CLEAR_USER_ACTIVITIES:
        return initialState;
    case PREPEND_USER_ACTIVITIES:
      return {
        ...state,
        events: [
          ...(state.events || []),
          ...action.payload.events,
        ],
      };
    default:
      return state;
  }
};